import React, { ReactElement } from 'react';

import { ProductsCardState } from 'features/products';
import { Col, Flex, Row, Typography } from 'components';

import ProductsCard, { ProductsCardSkeleton } from '../productsCard';
import { useSchool } from 'features/school';

interface ProductsListProps {
  products: ProductsCardState[];
  active?: boolean;
  evolution?: boolean;
  completed?: boolean;
  loading?: boolean;
}

const ProductsList = ({ products, evolution = false, active = false, completed = false, loading = false }: ProductsListProps): ReactElement => {
  const { schoolUuid } = useSchool();

  let whenNoResults = 'Nenhum curso encontrado.';

  if (completed) whenNoResults = 'Você não possui nenhum curso encerrado.';

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';

  if (isBenndorf) {
    whenNoResults = 'Nenhum produto encontrado.';

    if (completed) whenNoResults = 'Você não possui nenhum produto encerrado.';
  } else if (isMeuPlanoCrypto) {
    whenNoResults = 'Nenhum conteúdo encontrado.';

    if (completed) whenNoResults = 'Você não possui nenhum conteúdo encerrado.';
  }

  return loading ? (
    <Row gutter={20} mt={2}>
      {Array(4)
        .fill(null)
        .map((product, index) => (
          <Col key={`product-card-skeleton-${index.toString()}}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }}>
            <ProductsCardSkeleton />
          </Col>
        ))}
    </Row>
  ) : products?.length ? (
    <Row gutter={20} mt={2}>
      {products.map((product, index) => (
        <Col key={`product-card-${product.uuid}-${index.toString()}}`} width={{ m: 1, t: 1 / 2, d: 1 / 4 }} mt={4}>
          <ProductsCard active={active} evolution={evolution} product={product} />
        </Col>
      ))}
    </Row>
  ) : (
    <Flex mt={30}>
      <Typography type="type3" color="alert_400">
        {whenNoResults}
      </Typography>
    </Flex>
  );
};

export default ProductsList;
